import { activeDeals, formatMoney } from "@/mocks/managerWorkspace";

export default function ActiveDealsWidget() {
  const totalAmount = activeDeals.reduce((sum, d) => sum + d.amount, 0);
  const totalDeals = activeDeals.length;
  const visibleDeals = activeDeals.slice(0, 6);

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#D4EDDA] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-shake-hands-line text-[12px] text-[#2D6A4F]"></i>
          <span className="text-[11px] font-semibold text-[#2D6A4F]">Активные сделки</span>
          <span className="text-[10px] text-[#666666]">({totalDeals})</span>
        </div>
        <span className="text-[10px] font-semibold text-[#2D6A4F]">{formatMoney(totalAmount)}</span>
      </div>
      <div className="flex-1 overflow-y-auto">
        <table className="w-full text-[10px]">
          <thead className="bg-[#FFF9E6] border-b border-[#D5CA8A] sticky top-0">
            <tr className="text-[#666666]">
              <th className="text-left px-2 py-1.5 font-medium whitespace-nowrap">Сделка</th>
              <th className="text-left px-2 py-1.5 font-medium whitespace-nowrap">Клиент</th>
              <th className="text-right px-2 py-1.5 font-medium whitespace-nowrap">Сумма</th>
              <th className="text-left px-2 py-1.5 font-medium whitespace-nowrap">Этап</th>
            </tr>
          </thead>
          <tbody>
            {visibleDeals.map((deal, i) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/20 transition-colors cursor-pointer">
                <td className="px-2 py-1.5 text-[#666666] whitespace-nowrap">{deal.dealId}</td>
                <td className="px-2 py-1.5 text-[#2D2D2D] font-medium whitespace-nowrap">{deal.client}</td>
                <td className="px-2 py-1.5 text-right font-semibold text-[#2D2D2D] whitespace-nowrap">{formatMoney(deal.amount)}</td>
                <td className="px-2 py-1.5">
                  <div className="flex items-center gap-1">
                    <span className={`inline-block w-1.5 h-1.5 rounded-full flex-shrink-0 ${
                      deal.stage === "Финальное согласование" ? "bg-[#2D6A4F]" :
                      deal.stage === "Переговоры" ? "bg-[#D97706]" :
                      deal.stage === "КП отправлено" ? "bg-[#B45309]" :
                      "bg-[#666666]"
                    }`}></span>
                    <span className="text-[#666666] whitespace-nowrap">{deal.stage}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все сделки
        </button>
      </div>
    </div>
  );
}